export const ar = {
  lang: 'ar',
  country: 'SA',
  flag: '🇸🇦',
  currency: 'ر.س',

  app: {
    sidebar: {
      dashboard: 'لوحة التحكم',
      transactions: 'المعاملات',
      pots: 'المحافظ',
      receipts: 'الإيصالات',
      reports: 'التقارير',
      categories: 'الفئات',
      tags: 'الوسوم',
      budgets: 'الميزانية',
      recurring: 'المتكررة',
      settings: 'الإعدادات',
      darkMode: 'الوضع الداكن',
      lightMode: 'الوضع الفاتح',
      logout: 'تسجيل الخروج',
    },
    common: {
      loading: 'جاري التحميل...',
      save: 'حفظ',
      cancel: 'إلغاء',
      confirmTitle: 'تأكيد',
      delete: 'حذف',
      edit: 'تعديل',
      create: 'إنشاء',
      search: 'بحث',
      filter: 'تصفية',
      export: 'تصدير',
      type: 'النوع',
      category: 'الفئة',
      date: 'التاريخ',
      amount: 'المبلغ',
      description: 'الوصف',
      actions: 'الإجراءات',
      income: 'دخل',
      expense: 'مصروف',
      name: 'الاسم',
      color: 'اللون',
      confirmDelete: 'هل أنت متأكد من الحذف؟',
      noResults: 'لم يتم العثور على نتائج',
      status: 'الحالة',
      error: 'خطأ',
      success: 'نجاح',
      page: 'صفحة',
      of: 'من',
      showing: 'عرض',
      viewDetails: 'عرض التفاصيل',
      tags: 'الوسوم',
      receipt: 'إيصال',
      receiptAttached: 'إيصال مرفق',
    },
    categoryLabels: {
      food: 'طعام',
      transport: 'مواصلات',
      shopping: 'تسوق',
      entertainment: 'ترفيه',
      health: 'صحة',
      education: 'تعليم',
      utilities: 'فواتير',
      housing: 'سكن',
      travel: 'سفر',
      other: 'أخرى',
      salary: 'راتب',
      investment: 'استثمار',
      freelance: 'عمل حر',
      gift: 'هدية',
    },
    tags: {
      loading: 'جاري تحميل الوسوم...',
      error: 'تعذر تحميل الوسوم. حاول مرة أخرى.',
      title: 'الوسوم',
      subtitle: 'أنشئ وسوماً لتنظيم وتصفية معاملاتك',
      newTag: 'وسم جديد',
      noTags: 'لا توجد وسوم',
      noTagsDescription: 'يتم إنشاء الوسوم تلقائياً عند استخدام #وسم في رسائلك، أو يمكنك إنشاؤها يدوياً هنا.',
      createFirst: 'إنشاء أول وسم',
      howToUse: 'كيفية استخدام الوسوم',
      howToUseDescription: 'أضف وسوماً لمعاملاتك عبر واتساب باستخدام #وسم. مثال: "غداء 35 ريال #عمل #طعام". تساعد الوسوم في تصفية وتحليل مصروفاتك.',
      form: {
        name: 'اسم الوسم',
        namePlaceholder: 'عمل، سفر، طعام...',
        nameHint: 'سيتم تحويله إلى أحرف صغيرة بدون مسافات',
        color: 'اللون',
      },
      stats: {
        title: 'الإحصائيات',
        created: 'الوسوم المنشأة',
        totalUsage: 'إجمالي الاستخدام',
        mostUsed: 'الأكثر استخداماً',
        unused: 'غير مستخدم',
      },
      confirmDelete: 'حذف الوسم',
      deleteWarning: 'هل أنت متأكد من حذف الوسم',
      deleteUsageWarning: 'هذا الوسم مستخدم في {count} معاملة. سيتم إزالة الوسم من هذه المعاملات.',
    },
    pots: {
      title: 'المحافظ',
      subtitle: 'نظم أموالك في محافظ مختلفة حسب العملة',
      loading: 'جاري تحميل المحافظ...',
      error: 'تعذر تحميل المحافظ. حاول مرة أخرى.',
      errorTitle: 'خطأ في تحميل المحافظ',
      newPot: 'محفظة جديدة',
      editPot: 'تعديل المحفظة',
      noPots: 'لا توجد محافظ',
      noPotsDescription: 'أنشئ محافظ لتنظيم أموالك حسب العملة أو الهدف.',
      createFirst: 'إنشاء أول محفظة',
      setDefault: 'تعيين كافتراضي',
      transactions: 'معاملات',
      confirmDelete: 'حذف المحفظة',
      confirmDeleteMessage: 'هل أنت متأكد من حذف المحفظة',
      deleteWarning: 'تحتوي هذه المحفظة على {count} معاملة سيتم نقلها إلى المحفظة الافتراضية.',
      form: {
        name: 'الاسم',
        namePlaceholder: 'مثال: صندوق الطوارئ',
        description: 'الوصف (اختياري)',
        descriptionPlaceholder: 'ما الغرض من هذه المحفظة؟',
        currency: 'العملة',
        color: 'اللون',
      },
    },
    transactions: {
      loading: 'جاري تحميل المعاملات...',
      title: 'المعاملات',
      subtitle: 'أدر دخلك ومصروفاتك',
      searchPlaceholder: 'البحث بالوصف، التاجر...',
      showing: 'عرض {count} من {total} معاملة',
      confirmDelete: 'هل أنت متأكد من حذف هذه المعاملة؟',
      filters: {
        filters: 'التصفية',
        dateStart: 'تاريخ البداية',
        dateEnd: 'تاريخ النهاية',
        startDate: 'تاريخ البداية',
        endDate: 'تاريخ النهاية',
        minAmount: 'الحد الأدنى للمبلغ',
        maxAmount: 'الحد الأقصى للمبلغ',
      },
      table: {
        description: 'الوصف',
        category: 'الفئة',
        date: 'التاريخ',
        amount: 'المبلغ',
        receipt: 'الإيصال',
        actions: 'الإجراءات',
      },
      viewReceipt: 'عرض الإيصال',
      modal: {
        editTitle: 'تعديل المعاملة',
        detailsTitle: 'تفاصيل المعاملة',
        merchant: 'التاجر',
        description: 'الوصف',
        tags: 'الوسوم',
        receipt: 'الإيصال',
        receiptAttached: 'إيصال مرفق',
        createCategory: 'إنشاء فئة جديدة',
      },
    },
    dashboard: {
      title: 'لوحة التحكم',
      subtitle: 'نظرة عامة على وضعك المالي',
      period: {
        week: 'أسبوع',
        month: 'شهر',
        year: 'سنة',
      },
      cards: {
        income: 'الدخل',
        expense: 'المصروفات',
        expenses: 'المصروفات',
        balance: 'الرصيد',
        transactions: 'المعاملات',
      },
      charts: {
        spending: 'المصروفات حسب الفئة',
        trend: 'الاتجاه',
        byCategory: 'المصروفات حسب الفئة',
      },
      recent: 'المعاملات الأخيرة',
      viewAll: 'عرض الكل',
      topCategories: 'أعلى الفئات',
      items: 'عناصر',
      loading: 'جاري تحميل لوحة التحكم...',
    },
    settings: {
      title: 'الإعدادات',
      subtitle: 'أدر ملفك الشخصي وتفضيلاتك',
      profile: {
        title: 'الملف الشخصي',
        phone: 'الهاتف',
        phoneVerified: 'تم التحقق',
        phoneHint: 'يُستخدم الهاتف للمصادقة ولا يمكن تغييره هنا.',
        name: 'الاسم',
        namePlaceholder: 'اسمك',
        email: 'البريد الإلكتروني',
        emailPlaceholder: 'بريدك@email.com',
        emailHint: 'يُستخدم لاستلام التقارير والإشعارات.',
        verified: 'تم التحقق',
      },
      preferences: {
        title: 'التفضيلات',
        language: 'اللغة',
        languageHint: 'اللغة المستخدمة في رسائل واتساب والتقارير.',
        timezone: 'المنطقة الزمنية',
      },
      subscription: {
        title: 'الاشتراك',
        plan: 'الخطة',
        status: {
          active: 'نشط',
          trialing: 'تجريبي',
          pastDue: 'متأخر السداد',
          past_due: 'متأخر السداد',
          canceled: 'ملغى',
          expired: 'منتهي',
        },
        trialEnds: 'ينتهي التجريبي في',
        trialEndsAt: 'ينتهي التجريبي في',
        nextBilling: 'الفاتورة القادمة',
        upgrade: 'ترقية',
        support: 'تواصل مع الدعم',
        contactSupport: 'تواصل مع الدعم',
        cancel: 'إلغاء الاشتراك',
        noSubscription: 'لا يوجد اشتراك نشط',
        noSubscriptionDesc: 'اشترك في خطة لفتح جميع المميزات.',
        viewPlans: 'عرض الخطط',
        plans: {
          free: 'مجاني',
          basic: 'أساسي',
          starter: 'مبتدئ',
          pro: 'احترافي',
          professional: 'احترافي',
          enterprise: 'للمؤسسات',
          vip: 'VIP',
        },
      },
      account: {
        title: 'معلومات الحساب',
        id: 'معرف الحساب',
        createdAt: 'تاريخ إنشاء الحساب',
      },
      saveChanges: 'حفظ التغييرات',
      loading: 'جاري تحميل الإعدادات...',
      error: 'خطأ في تحميل الإعدادات',
      errorDesc: 'تعذر تحميل معلوماتك. حاول مرة أخرى.',
    },
    budgets: {
      title: 'الميزانيات',
      subtitle: 'حدد حدود الإنفاق حسب الفئة',
      loading: 'جاري تحميل الميزانيات...',
      error: 'خطأ في تحميل الميزانيات',
      errorDesc: 'تعذر تحميل ميزانياتك. حاول مرة أخرى.',
      newBudget: 'ميزانية جديدة',
      noBudgets: 'لا توجد ميزانيات',
      noBudgetsDesc: 'أنشئ ميزانيات للتحكم في إنفاقك حسب الفئة وتلقي التنبيهات.',
      createFirst: 'إنشاء أول ميزانية',
      period: {
        monthly: 'شهري',
        yearly: 'سنوي',
      },
      status: {
        safe: 'ضمن الميزانية',
        warning: 'قريب من الحد',
        danger: 'تجاوز الحد!',
      },
      spent: 'أنفق',
      limit: 'الحد',
      remaining: 'المتبقي',
      exceeded: 'تجاوز',
      summary: {
        totalBudgeted: 'إجمالي الميزانية',
        totalSpent: 'إجمالي الإنفاق',
        overBudget: 'تجاوز الميزانية',
        budget: 'ميزانية',
        budgets: 'ميزانيات',
      },
      tips: {
        title: 'نصائح لميزانية جيدة',
        tip1: 'ابدأ بالفئات التي تنفق فيها أكثر',
        tip2: 'حدد حدوداً واقعية بناءً على سجلك',
        tip3: 'استخدم تنبيه 80% للتصرف قبل التجاوز',
        tip4: 'راجع ميزانياتك شهرياً',
      },
      confirmDelete: 'حذف الميزانية',
      confirmDeleteMsg: 'هل أنت متأكد من حذف الميزانية',
      form: {
        newBudget: 'ميزانية جديدة',
        editBudget: 'تعديل الميزانية',
        budgetName: 'اسم الميزانية',
        budgetNamePlaceholder: 'مثال: طعام شهري، مواصلات...',
        category: 'الفئة (اختياري)',
        allExpenses: 'جميع المصروفات',
        limit: 'الحد',
        period: 'الفترة',
        alertThreshold: 'تنبيه عند الوصول إلى',
        alertDescription: 'سيتم إعلامك عندما تصل مصروفاتك إلى هذه النسبة من الحد.',
        preview: 'معاينة',
        save: 'حفظ',
        create: 'إنشاء',
      },
    },
    categories: {
      title: 'الفئات',
      subtitle: 'إدارة فئات الدخل والمصروفات',
      loading: 'جاري تحميل الفئات...',
      error: 'خطأ في تحميل الفئات',
      errorDesc: 'تعذر تحميل فئاتك. حاول مرة أخرى.',
      newCategory: 'فئة جديدة',
      myCategories: 'فئاتي',
      systemCategories: 'فئات النظام',
      systemCategoriesDesc: 'هذه الفئات افتراضية ولا يمكن تعديلها.',
      noCustomCategories: 'لا توجد فئات مخصصة',
      noCustomCategoriesDesc: 'أنشئ فئات مخصصة لتنظيم أفضل لماليتك.',
      createFirst: 'إنشاء أول فئة',
      type: {
        income: 'دخل',
        expense: 'مصروف',
      },
      deductible: 'قابل للخصم',
      confirmDelete: 'حذف الفئة',
      confirmDeleteMsg: 'هل أنت متأكد من حذف الفئة',
      deleteWarning: 'سيتم نقل المعاملات الحالية إلى "أخرى".',
      form: {
        newCategory: 'فئة جديدة',
        editCategory: 'تعديل الفئة',
        categoryName: 'اسم الفئة',
        categoryNamePlaceholder: 'مثال: طعام، مواصلات...',
        type: 'النوع',
        icon: 'الأيقونة',
        colour: 'اللون',
        preview: 'معاينة',
        taxDeductible: 'قابل للخصم الضريبي',
        save: 'حفظ',
        create: 'إنشاء',
      },
    },
    receipts: {
      title: 'الإيصالات',
      subtitle: 'عرض وإدارة مستنداتك الضريبية',
      loading: 'جاري تحميل الإيصالات...',
      error: 'خطأ في تحميل الإيصالات',
      errorDesc: 'تعذر تحميل إيصالاتك. حاول مرة أخرى.',
      status: {
        all: 'جميع الحالات',
        processing: 'قيد المعالجة',
        completed: 'مكتملة',
        failed: 'فشلت',
        manual_review: 'مراجعة يدوية',
      },
      year: {
        all: 'جميع السنوات',
      },
      stats: {
        total: 'الإجمالي',
        completed: 'مكتملة',
        processing: 'قيد المعالجة',
        failed: 'فشلت',
      },
      noReceipts: 'لا توجد إيصالات',
      noReceiptsFiltered: 'لم يتم العثور على إيصالات',
      noReceiptsDesc: 'أرسل صورة إيصال عبر واتساب للبدء',
      noReceiptsFilteredDesc: 'اضبط الفلاتر لرؤية المزيد من الإيصالات',
      showing: 'عرض {count} من {total} إيصال',
      page: 'صفحة {current} من {total}',
    },
    recurring: {
      title: 'المعاملات المتكررة',
      subtitle: 'أتمتة مصاريفك ودخلك الثابت',
      loading: 'جاري تحميل المعاملات المتكررة...',
      error: 'خطأ في تحميل المعاملات المتكررة',
      errorDesc: 'تعذر تحميل معاملاتك المتكررة. حاول مرة أخرى.',
      newRecurring: 'معاملة متكررة جديدة',
      noRecurring: 'لا توجد معاملات متكررة',
      noRecurringDesc: 'أنشئ معاملات تتكرر تلقائياً، مثل الإيجار أو الاشتراكات أو الراتب.',
      createFirst: 'إنشاء أول معاملة متكررة',
      active: 'نشطة',
      paused: 'متوقفة',
      activeCount: 'نشطة ({count})',
      pausedCount: 'متوقفة ({count})',
      next: 'التالية',
      summary: {
        monthlyExpenses: 'المصروفات الشهرية',
        monthlyIncome: 'الدخل الشهري',
        netMonthly: 'الصافي الشهري',
      },
      frequency: {
        daily: 'يومية',
        weekly: 'أسبوعية',
        monthly: 'شهرية',
        yearly: 'سنوية',
      },
      dayOf: {
        everyDay: 'كل يوم',
        every: 'كل',
        dayOfMonth: 'اليوم {day}',
        annually: 'سنوياً',
      },
      actions: {
        pause: 'إيقاف مؤقت',
        activate: 'تفعيل',
        processNow: 'معالجة الآن',
      },
      tips: {
        title: 'حول المعاملات المتكررة',
        tip1: 'يتم إنشاء المعاملات تلقائياً في التاريخ المحدد',
        tip2: 'يمكنك الإيقاف مؤقتاً دون الحذف',
        tip3: 'استخدم للمصاريف الثابتة مثل الإيجار والكهرباء والإنترنت',
        tip4: 'يعمل أيضاً للدخل مثل الراتب',
      },
      confirmDelete: 'حذف المعاملة المتكررة',
      confirmDeleteMsg: 'هل أنت متأكد من حذف المعاملة المتكررة',
      deleteWarning: 'لن تتأثر المعاملات التي تم إنشاؤها بالفعل.',
      form: {
        newRecurring: 'معاملة متكررة جديدة',
        editRecurring: 'تعديل المعاملة المتكررة',
        description: 'الوصف',
        descriptionPlaceholder: 'مثال: إيجار، نتفليكس، راتب...',
        amount: 'المبلغ',
        category: 'الفئة',
        selectCategory: 'اختر فئة',
        selectPot: 'اختر محفظة (اختياري)',
        frequencyLabel: 'التكرار',
        dayOfMonth: 'يوم الشهر',
        dayOfWeek: 'يوم الأسبوع',
        day: 'اليوم',
        startDate: 'تاريخ البدء',
        endDate: 'تاريخ الانتهاء (اختياري)',
        preview: 'معاينة',
        save: 'حفظ',
        create: 'إنشاء',
        daysOfWeek: {
          monday: 'الإثنين',
          tuesday: 'الثلاثاء',
          wednesday: 'الأربعاء',
          thursday: 'الخميس',
          friday: 'الجمعة',
          saturday: 'السبت',
          sunday: 'الأحد',
        },
      },
    },
    reports: {
      title: 'التقارير الضريبية',
      subtitle: 'ملخصات سنوية للإقرار الضريبي',
      loading: 'جاري تحميل التقارير...',
      error: 'خطأ في تحميل التقارير',
      errorDesc: 'تعذر تحميل تقاريرك. حاول مرة أخرى.',
      year: {
        all: 'جميع السنوات',
      },
      noReports: 'لا توجد تقارير',
      noReportsFiltered: 'لم يتم العثور على تقارير',
      noReportsDesc: 'ستظهر تقاريرك الضريبية هنا في نهاية كل سنة.',
      noReportsFilteredDesc: 'لا توجد تقارير لسنة {year}.',
      generatedOn: 'تم إنشاؤه في',
      card: {
        income: 'الدخل',
        expenses: 'المصروفات',
        deductible: 'قابل للخصم',
        balance: 'الرصيد',
      },
      country: {
        BR: 'البرازيل',
        GB: 'المملكة المتحدة',
      },
      tips: {
        title: 'حول التقارير الضريبية',
        desc: 'يتم إنشاء التقارير تلقائياً في نهاية كل سنة ضريبية.',
        tip1: 'البرازيل: السنة الضريبية من يناير إلى ديسمبر',
        tip2: 'المملكة المتحدة: السنة الضريبية من أبريل إلى مارس',
      },
    },
  },

  nav: {
    pricing: 'الأسعار',
    features: 'المميزات',
    howItWorks: 'كيف يعمل',
    login: 'تسجيل الدخول',
  },

  hero: {
    badge: 'إدارة مالية بدون تعقيد',
    title: 'نظم أموالك عبر واتساب',
    subtitle: 'أرسل رسالة نصية أو صورة أو مقطع صوتي. الذكاء الاصطناعي يسجل ويصنف وينظم كل شيء لك.',
    cta: 'ابدأ مجاناً',
    ctaSubtext: '14 يوم مجاناً، بدون بطاقة',
    ukOnly: 'متاح حالياً فقط لأرقام المملكة المتحدة',
    trustedBy: 'سهل كإرسال رسالة',
  },

  howItWorks: {
    title: 'كيف يعمل',
    subtitle: 'ثلاث طرق للتسجيل. بدون أي جهد.',
    step1: {
      icon: '💬',
      title: 'نص',
      description: 'اكتب بشكل طبيعي: "50 غداء"، "+500 راتب"، "أوبر أمس كان للعمل"',
      example: '"85 بقالة"',
    },
    step2: {
      icon: '📸',
      title: 'صورة',
      description: 'أرسل صورة الإيصال. يستخرج OCR المبلغ والمتجر والتفاصيل تلقائياً.',
      example: 'صورة الفاتورة',
    },
    step3: {
      icon: '🎤',
      title: 'صوت',
      description: 'سجل مقطعاً صوتياً تصف فيه المصروف. نحوله إلى نص ونسجله.',
      example: '"صرفت 200 في البنزين"',
    },
  },

  features: {
    title: 'أكثر من مجرد تسجيل مصروفات',
    subtitle: 'أدوات قوية، واجهة بسيطة',
    list: [
      {
        icon: 'wallet',
        title: 'المحافظ',
        description: 'نظم حسب الحساب: الراجحي، الأهلي، مشروع س. كل محفظة بعملتها.',
        command: '"أنشئ محفظة الراجحي"',
      },
      {
        icon: 'target',
        title: 'الميزانيات',
        description: 'حدد سقفاً لكل فئة. تنبيه عند الوصول لـ 80%.',
        command: '"ميزانية 500 طعام"',
      },
      {
        icon: 'hash',
        title: 'الوسوم',
        description: 'استخدم #هاشتاق للتنظيم: "50 أوبر #عميل #مشروع-س"',
        command: '"مصروفاتي #عمل"',
      },
      {
        icon: 'repeat',
        title: 'المتكررة',
        description: 'اضبط المصروفات الثابتة. الإيجار، نتفلكس، الراتب - يُسجل تلقائياً.',
        command: '"أنشئ متكرر 1500 إيجار"',
      },
      {
        icon: 'globe',
        title: 'متعدد العملات',
        description: 'ر.س، $، €، £. أسعار صرف محدثة. لوحة تحكم موحدة.',
        command: '"50 دولار غداء محفظة السفر"',
      },
      {
        icon: 'layout',
        title: 'لوحة تحكم ويب',
        description: 'رسوم بيانية، فلاتر، تصدير. كل ما تسجله، تراه في البوابة.',
        command: 'keepnota.com',
      },
    ],
  },

  commands: {
    title: 'أوامر سريعة',
    subtitle: 'محادثة طبيعية. بدون حفظ أي شيء.',
    list: [
      { cmd: '50 قهوة', desc: 'يسجل مصروف 50 ريال' },
      { cmd: '+2000 عمل حر', desc: 'يسجل دخل' },
      { cmd: 'ملخص', desc: 'يعرض ملخص الشهر' },
      { cmd: 'محافظي', desc: 'يعرض قائمة محافظك' },
      { cmd: 'احذف الأخير', desc: 'يحذف آخر معاملة' },
      { cmd: 'مساعدة', desc: 'يعرض كل الأوامر' },
    ],
  },

  audience: {
    title: 'صُمم لمن يريد البساطة',
    subtitle: 'إذا كنت تستخدم واتساب، فأنت تعرف كيف تستخدم KeepNota',
    personas: [
      {
        icon: 'briefcase',
        title: 'المستقلون وأصحاب المشاريع الصغيرة',
        description: 'افصل الشخصي عن العمل. اعرف بالضبط كم يدخل ويخرج.',
      },
      {
        icon: 'user',
        title: 'الشؤون المالية الشخصية',
        description: 'كفى جداول بيانات. سجل مصروفاتك لحظة حدوثها.',
      },
      {
        icon: 'users',
        title: 'الأزواج والعائلات',
        description: 'محافظ مشتركة. كل واحد يسجل، الجميع يتابع.',
      },
      {
        icon: 'plane',
        title: 'المسافرون',
        description: 'تعدد العملات تلقائي. مصروفات في أي مكان، كلها محولة.',
      },
    ],
  },

  comparison: {
    title: 'لماذا KeepNota؟',
    subtitle: 'مقارنة بالبدائل',
    vsSpreadsheet: {
      title: 'مقابل جداول البيانات',
      points: [
        'بدون فتح الكمبيوتر',
        'تسجيل فوري',
        'يصنف تلقائياً',
        'صورة الإيصال = كل شيء مملوء',
      ],
    },
    vsApps: {
      title: 'مقابل تطبيقات المالية',
      points: [
        'يعمل على واتساب (تستخدمه يومياً)',
        'صفر تعقيد - فقط أرسل رسالة',
        'OCR للإيصالات مضمن',
        'بدون إشعارات مزعجة',
      ],
    },
    vsManual: {
      title: 'مقابل التسجيل اليدوي',
      points: [
        'لن تنسى التسجيل أبداً',
        'صوت عندما لا تستطيع الكتابة',
        'السجل دائماً متاح',
        'تقارير تلقائية',
      ],
    },
  },

  taxBonus: {
    title: 'مكافأة: جاهز للضرائب',
    subtitle: 'عندما يحين الوقت، بياناتك منظمة مسبقاً',
    points: [
      'فئات مخصصة للخصومات الضريبية',
      'استخراج تلقائي لمعلومات التاجر من الإيصالات',
      'تقرير سنوي قابل للتصدير',
      'افصل المصروفات القابلة للخصم بالوسوم',
    ],
  },

  pricing: {
    title: 'الخطط',
    subtitle: 'ابدأ مجاناً. قم بالترقية عند الحاجة.',
    monthly: '/شهر',
    yearly: '/سنة',
    savePercent: 'وفر 20%',
    basic: {
      name: 'أساسي',
      price: '19.90',
      features: [
        '30 صورة إيصال/شهر',
        '20 مقطع صوتي/شهر',
        'رسائل نصية غير محدودة',
        'لوحة تحكم ورسوم بيانية أساسية',
        'تقرير شهري',
        'تصدير CSV',
        'حفظ الإيصالات: سنة واحدة',
      ],
    },
    pro: {
      name: 'احترافي',
      price: '39.90',
      popular: 'الأكثر شعبية',
      features: [
        'صور ومقاطع صوتية غير محدودة',
        'كل مميزات الأساسي +',
        'رسوم بيانية وفلاتر متقدمة',
        'مقارنة شهر بشهر',
        'تصدير PDF',
        'تقرير سنوي (ضريبي)',
        'دعم ذو أولوية',
        'حفظ الإيصالات: سنتان',
      ],
    },
    cta: 'ابدأ مجاناً',
    trial: '14 يوم مجاناً، ألغِ في أي وقت',
  },

  referral: {
    title: 'أحِل واربح',
    subtitle: 'شارك مع أصدقائك واحصل على أيام مجانية',
    tiers: [
      { range: '1-5 إحالات', reward: '7 أيام مجانية لكل إحالة' },
      { range: '6-15 إحالة', reward: '10 أيام مجانية لكل إحالة' },
      { range: '16+ إحالة', reward: '14 يوم + رصيد' },
    ],
    cta: 'اعرف المزيد',
  },

  faq: {
    title: 'الأسئلة الشائعة',
    items: [
      {
        q: 'هل أحتاج لتحميل تطبيق؟',
        a: 'لا! يعمل 100% عبر واتساب. فقط احفظ رقمنا وابدأ بإرسال مصروفاتك. لدينا أيضاً بوابة ويب لعرض الرسوم البيانية والتقارير.',
      },
      {
        q: 'هل بياناتي آمنة؟',
        a: 'نعم! نستخدم التشفير من طرف لطرف، خوادم آمنة، ونتبع معايير حماية البيانات. يمكنك تصدير أو حذف بياناتك في أي وقت.',
      },
      {
        q: 'هل يمكنني الإلغاء في أي وقت؟',
        a: 'بالتأكيد! بدون التزام. ألغِ في أي وقت عبر واتساب بكتابة "إلغاء". تبقى بياناتك متاحة لمدة 30 يوماً بعد الإلغاء.',
      },
      {
        q: 'هل يعمل للمستقلين وأصحاب المشاريع الصغيرة؟',
        a: 'مثالي لذلك! استخدم المحافظ لفصل الحساب الشخصي عن العمل، والوسوم للعملاء، وتحكم كامل في الدخل والمصروفات.',
      },
      {
        q: 'كيف يعمل OCR للإيصالات؟',
        a: 'أرسل صورة الفاتورة أو الإيصال. يستخرج الذكاء الاصطناعي تلقائياً: المبلغ الإجمالي، اسم المتجر، التاريخ وحتى العناصر. فقط تأكد وانتهى.',
      },
      {
        q: 'هل يمكنني استخدام أكثر من عملة؟',
        a: 'نعم! ندعم الريال، الدولار، اليورو والجنيه الإسترليني. كل محفظة يمكن أن تكون بعملتها، ولوحة التحكم تعرض الكل محولاً لعملتك الرئيسية.',
      },
    ],
  },

  cta: {
    title: 'ابدأ بتنظيم أموالك اليوم',
    subtitle: '14 يوم مجاناً. بدون بطاقة. ألغِ في أي وقت.',
    button: 'تواصل عبر واتساب',
    secondary: 'شاهد العرض التوضيحي',
  },

  footer: {
    copyright: '© 2025 KeepNota by Fig and Rosa Ltd. جميع الحقوق محفوظة.',
    terms: 'شروط الاستخدام',
    privacy: 'الخصوصية',
    tagline: 'إدارة مالية عبر واتساب',
  },

  privacy: {
    title: 'سياسة الخصوصية',
    lastUpdate: 'آخر تحديث: ديسمبر 2024',
    intro: 'تقدر KeepNota ("نحن" أو "خدمتنا") خصوصية المستخدمين. توضح سياسة الخصوصية هذه كيف نجمع ونستخدم ونحمي معلوماتك.',
    sections: [
      {
        title: '1. البيانات التي نجمعها',
        content: `نجمع البيانات التالية عند استخدامك KeepNota:
• **رقم الهاتف**: للتعريف والتواصل عبر واتساب
• **الرسائل المرسلة**: النصوص والمقاطع الصوتية وصور الإيصالات التي ترسلها
• **البيانات المستخرجة**: المبالغ والفئات ومعلومات الإيصالات المعالجة
• **بيانات الاستخدام**: أوقات الوصول والتفاعل مع الخدمة`,
      },
      {
        title: '2. كيف نستخدم بياناتك',
        content: `نستخدم بياناتك من أجل:
• معالجة وتنظيم إيصالاتك
• إنشاء تقارير ورسوم بيانية للمصروفات
• تحديد المصروفات القابلة للخصم الضريبي
• تحسين خدماتنا وخوارزميات الذكاء الاصطناعي
• إرسال اتصالات حول حسابك والخدمة`,
      },
      {
        title: '3. التخزين والأمان',
        content: `بياناتك مخزنة بأمان:
• تشفير أثناء النقل (HTTPS/TLS)
• تخزين على خوادم آمنة
• وصول مقيد للأنظمة الآلية فقط
• نسخ احتياطية منتظمة وتكرار البيانات`,
      },
      {
        title: '4. مشاركة البيانات',
        content: `**لا نبيع بياناتك.** نشارك فقط مع:
• **مزودي الخدمة**: معالجة المدفوعات (Stripe)، التخزين (AWS)
• **الذكاء الاصطناعي**: Google (Gemini) لمعالجة الصور والنصوص - بيانات مجهولة
• **الالتزام القانوني**: عند الطلب بموجب القانون أو أمر قضائي`,
      },
      {
        title: '5. حقوقك',
        content: `لديك الحق في:
• **الوصول**: طلب نسخة من بياناتك
• **التصحيح**: تصحيح البيانات غير الصحيحة
• **الحذف**: طلب حذف بياناتك
• **النقل**: استلام بياناتك بتنسيق منظم
• **الإلغاء**: إلغاء الموافقة في أي وقت

لممارسة حقوقك، أرسل رسالة إلى واتساب أو البريد الإلكتروني: privacy@keepnota.com`,
      },
      {
        title: '6. الاحتفاظ بالبيانات',
        content: `نحتفظ ببياناتك طالما حسابك نشط. بعد الإلغاء:
• البيانات المالية: تُحفظ لمدة 5 سنوات (التزام ضريبي)
• صور الإيصالات: تُحذف خلال 30 يوماً
• بيانات الحساب: تُحذف خلال 30 يوماً`,
      },
      {
        title: '7. التواصل',
        content: `للاستفسارات حول الخصوصية:
• البريد الإلكتروني: privacy@keepnota.com
• واتساب: أرسل "خصوصية" إلى رقمنا`,
      },
    ],
  },

  feedback: {
    title: 'أرسل ملاحظاتك',
    subtitle: 'رأيك يساعدنا على تحسين KeepNota',
    typeLabel: 'نوع الملاحظة',
    types: {
      general: 'عام',
      feature_request: 'اقتراح',
      bug: 'خطأ/مشكلة',
      complaint: 'شكوى',
      praise: 'إشادة',
      account_deletion: 'حذف الحساب',
    },
    messageLabel: 'رسالتك',
    messagePlaceholder: 'أخبرنا برأيك...',
    ratingLabel: 'التقييم (اختياري)',
    nameLabel: 'اسمك (اختياري)',
    namePlaceholder: 'كيف يمكننا مناداتك؟',
    emailLabel: 'البريد الإلكتروني (اختياري)',
    emailPlaceholder: 'بريدك@email.com',
    emailHint: 'للرد على ملاحظاتك',
    submit: 'إرسال الملاحظات',
    errors: {
      messageRequired: 'يرجى كتابة رسالة',
      messageTooShort: 'الرسالة قصيرة جداً (10 أحرف كحد أدنى)',
      submitFailed: 'فشل الإرسال. حاول مرة أخرى.',
    },
    success: {
      title: 'تم إرسال الملاحظات!',
      message: 'شكراً لمشاركة رأيك. سنراجعه باهتمام.',
    },
    backToHome: 'العودة للصفحة الرئيسية',
  },

  terms: {
    title: 'شروط الاستخدام',
    lastUpdate: 'آخر تحديث: ديسمبر 2024',
    intro: 'باستخدام KeepNota، فإنك توافق على شروط الاستخدام هذه. يرجى القراءة بعناية.',
    sections: [
      {
        title: '1. حول الخدمة',
        content: `KeepNota هي خدمة لتنظيم الإيصالات والمصروفات عبر واتساب. نقدم:
• معالجة تلقائية للإيصالات بالصورة أو الصوت أو النص
• تصنيف وتنظيم المصروفات
• تقارير ورسوم بيانية للمصروفات
• تحديد المصروفات القابلة للخصم الضريبي

الخدمة مقدمة "كما هي" ويمكن تعديلها في أي وقت.`,
      },
      {
        title: '2. التسجيل والحساب',
        content: `لاستخدام KeepNota:
• يجب أن يكون عمرك 18 عاماً أو أكثر
• تقديم معلومات صحيحة
• الحفاظ على تحديث رقم هاتفك
• عدم مشاركة الوصول مع الآخرين

أنت مسؤول عن جميع الأنشطة في حسابك.`,
      },
      {
        title: '3. الاستخدام المقبول',
        content: `توافق على عدم:
• استخدام الخدمة لأغراض غير قانونية
• إرسال محتوى مسيء أو تشهيري أو غير قانوني
• محاولة الوصول لأنظمة أو بيانات مستخدمين آخرين
• استخدام الروبوتات أو الأتمتة غير المصرح بها
• إعادة بيع أو توزيع الخدمة`,
      },
      {
        title: '4. المدفوعات والاشتراك',
        content: `• نقدم فترة تجريبية مجانية لمدة 14 يوماً
• بعد التجربة، يتم تحصيل الاشتراك شهرياً
• المدفوعات تُعالج عبر Stripe (بطاقة ائتمان)
• يمكن الإلغاء في أي وقت
• لا يوجد استرداد للفترات الجزئية`,
      },
      {
        title: '5. الملكية الفكرية',
        content: `• KeepNota ومكوناتها ملك لـ Figrosa
• تحتفظ بملكية بياناتك وإيصالاتك
• نمنحك ترخيصاً محدوداً لاستخدام الخدمة
• تمنحنا ترخيصاً لمعالجة بياناتك حسب الحاجة`,
      },
      {
        title: '6. تحديد المسؤولية',
        content: `• KeepNota لا تحل محل المشورة المحاسبية أو الضريبية
• لا نضمن الدقة المطلقة في معالجة الإيصالات
• لسنا مسؤولين عن القرارات الضريبية المبنية على الخدمة
• مسؤوليتنا محدودة بقيمة المبلغ المدفوع للخدمة`,
      },
      {
        title: '7. الإلغاء',
        content: `يمكنك الإلغاء في أي وقت:
• أرسل "إلغاء" عبر واتساب
• ادخل حسابك في البوابة
• يستمر الوصول حتى نهاية الفترة المدفوعة
• ستُحذف بياناتك وفقاً لسياسة الخصوصية`,
      },
      {
        title: '8. تعديلات الشروط',
        content: `يمكننا تعديل هذه الشروط في أي وقت. سنُعلمك عبر:
• رسالة واتساب
• البريد الإلكتروني (إذا كان مسجلاً)
• إشعار في البوابة

الاستمرار في الاستخدام بعد التعديلات يعني الموافقة.`,
      },
      {
        title: '9. التواصل',
        content: `للاستفسارات حول الشروط:
• البريد الإلكتروني: support@keepnota.com
• واتساب: أرسل "مساعدة" إلى رقمنا`,
      },
    ],
  },
};
